var _rect, _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPreviousDropdownOption(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    focusable: "false",
    width: 29,
    height: 28,
    viewBox: "0 0 29 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    "aria-hidden": "true",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 28.5,
    y: 28,
    width: 28,
    height: 28,
    rx: 14,
    transform: "rotate(-180 28.5 28)",
    fill: "#EEEEEE"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_4178_12838)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11.28 13.283L11.6193 12.9258C11.6251 12.9197 11.6337 12.9177 11.6414 12.9107L16.0246 8.29593C16.3994 7.90136 17.0063 7.90136 17.3802 8.29593L17.7196 8.65215C18.0935 9.04671 18.0935 9.68549 17.7196 10.079L13.995 14.0005L17.7196 17.921C18.0935 18.3145 18.0935 18.9543 17.7196 19.3489L17.3802 19.7041C17.0063 20.0986 16.3994 20.0986 16.0246 19.7041L11.6414 15.0904C11.6347 15.0833 11.6251 15.0813 11.6193 15.0742L11.2799 14.718C11.092 14.5202 10.999 14.2598 11 14.0005C10.999 13.7402 11.092 13.4808 11.28 13.283Z",
    fill: "#212129"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_4178_12838"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 12,
    height: 12,
    fill: "white",
    transform: "translate(8.5 20) rotate(-90)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPreviousDropdownOption);
export default __webpack_public_path__ + "static/media/previous-dropdown-option.d1f931177e950bb40f7a7932c71ebf68.svg";
export { ForwardRef as ReactComponent };